var map = {
	"./Caissa/Caissa_bot_girl.svg": 93897,
	"./Caissa/Caissa_bot_horse.svg": 60689,
	"./Caissa/PlayAndLearnTabPatternMobile.svg": 8038,
	"./Caissa/PlayModeIcon.svg": 40333,
	"./Caissa/TournamenTab.svg": 980,
	"./Caissa/aqua_chess_pattern.svg": 28892,
	"./Caissa/chatbot/Parental_control_rules.svg": 23472,
	"./Caissa/chatbot/chessboard_stairs_chatbot_bg.svg": 94842,
	"./ChessPieces/Black-Rook.png": 91676,
	"./ChessPieces/Black-Rook.svg": 6704,
	"./ChessPieces/White-Rook.png": 94727,
	"./ChessPieces/White-Rook.svg": 74032,
	"./ChessPieces/whiterookscale.svg": 15042,
	"./Meetings/Coach.svg": 21971,
	"./Meetings/Instructor.svg": 67502,
	"./Meetings/Mentor.svg": 46182,
	"./Meetings/Pattern.svg": 35192,
	"./Meetings/Practice.svg": 77585,
	"./Meetings/csoc_expiry_icon.svg": 6100,
	"./Meetings/csoc_plan_expiring.svg": 95086,
	"./Otb/card_pattern.svg": 78980,
	"./Otb/corner_pattern.svg": 40539,
	"./Otb/otb_image.svg": 4947,
	"./Points/negativePoint.png": 7257,
	"./Points/positivePoint.png": 14956,
	"./RequestAccess/NoPlayer.svg": 57373,
	"./ReviewGame.png": 24927,
	"./Rules-image.png": 86700,
	"./Svgs/14_days_renew_icon.svg": 57261,
	"./Svgs/BeginnerDashboard/Background.svg": 89703,
	"./Svgs/BeginnerDashboard/BrightChampsLogo.svg": 40822,
	"./Svgs/BeginnerDashboard/Chessboard.svg": 2765,
	"./Svgs/BeginnerDashboard/FindSquare.svg": 53081,
	"./Svgs/BeginnerDashboard/GirlMathIcon.svg": 51977,
	"./Svgs/BeginnerDashboard/GirlMathIconMobile.svg": 32058,
	"./Svgs/BeginnerDashboard/Intersect.svg": 77275,
	"./Svgs/BeginnerDashboard/IntersectPattern.svg": 77434,
	"./Svgs/BeginnerDashboard/LearningRoadmap.svg": 36493,
	"./Svgs/BeginnerDashboard/PlayAGame.svg": 97345,
	"./Svgs/BeginnerDashboard/PracticePosition.svg": 28382,
	"./Svgs/BeginnerDashboard/pawnIcon.svg": 53273,
	"./Svgs/Bolt.svg": 85665,
	"./Svgs/Bullet.svg": 81899,
	"./Svgs/CCCurrency": 93832,
	"./Svgs/CCCurrency.tsx": 93832,
	"./Svgs/CCTicketIcon": 77318,
	"./Svgs/CCTicketIcon.tsx": 77318,
	"./Svgs/Ellipse.svg": 19376,
	"./Svgs/ExclamationIcon": 3639,
	"./Svgs/ExclamationIcon.tsx": 3639,
	"./Svgs/IncorrectMove.svg": 43076,
	"./Svgs/IsOngoing.svg": 79636,
	"./Svgs/LeagueDetail.svg": 54142,
	"./Svgs/Parental_control_rules.svg": 49317,
	"./Svgs/Play active.svg": 6341,
	"./Svgs/Play and Learn active.svg": 12314,
	"./Svgs/Play and Learn normal.svg": 83337,
	"./Svgs/Play normal.svg": 75821,
	"./Svgs/Play.svg": 32968,
	"./Svgs/Play_from_any_position.svg": 70014,
	"./Svgs/PlayandLearn.svg": 6700,
	"./Svgs/Rapid.svg": 82998,
	"./Svgs/Rectangle.svg": 34128,
	"./Svgs/Snail.svg": 26590,
	"./Svgs/Summary.svg": 70204,
	"./Svgs/Tournaments.svg": 15919,
	"./Svgs/addMember.svg": 64445,
	"./Svgs/androidqr.jpg": 75026,
	"./Svgs/appModalImage.jpg": 28562,
	"./Svgs/background_frames.svg": 56357,
	"./Svgs/bannerItems/header1.png": 52617,
	"./Svgs/bannerItems/header2.png": 36339,
	"./Svgs/bannerItems/header3.png": 33224,
	"./Svgs/bannerItems/left.png": 82244,
	"./Svgs/bannerItems/right.png": 34057,
	"./Svgs/bannerItems/topHeader.png": 32851,
	"./Svgs/bannerchakra.svg": 45784,
	"./Svgs/beginIg.svg": 11220,
	"./Svgs/blue-chessboard.jpg": 5556,
	"./Svgs/blue.svg": 23477,
	"./Svgs/book-check.svg": 62353,
	"./Svgs/book-open.svg": 50769,
	"./Svgs/bottomShadow.svg": 54369,
	"./Svgs/bottombg.svg": 19821,
	"./Svgs/brief_logo.png": 82054,
	"./Svgs/bronzeMedal.svg": 64299,
	"./Svgs/brownleft.svg": 81402,
	"./Svgs/brownright.svg": 11897,
	"./Svgs/caissaAvatar.svg": 68779,
	"./Svgs/callBgPattern.svg": 11856,
	"./Svgs/cameraPlus.svg": 17036,
	"./Svgs/cc-logo-dark.svg": 20800,
	"./Svgs/cc-logo-light.svg": 80984,
	"./Svgs/ccIcon.svg": 99673,
	"./Svgs/cc_logo.png": 49109,
	"./Svgs/ccleague.svg": 46285,
	"./Svgs/challengehover.svg": 11213,
	"./Svgs/chatLogo.svg": 32211,
	"./Svgs/checksquare.svg": 62667,
	"./Svgs/chessboard.svg": 63467,
	"./Svgs/chesscom.png": 87332,
	"./Svgs/chessdotcom.svg": 97845,
	"./Svgs/chevronDoubleDown.svg": 24719,
	"./Svgs/chevronDoubleUp.svg": 79972,
	"./Svgs/circle_chess_back_half.png": 35711,
	"./Svgs/coinBackgoundForGoals.svg": 24176,
	"./Svgs/coinInRewards.svg": 4580,
	"./Svgs/coming_soon.png": 8988,
	"./Svgs/coming_soon_2.png": 46429,
	"./Svgs/congrats.svg": 94259,
	"./Svgs/connection_change.svg": 57812,
	"./Svgs/correct.svg": 18628,
	"./Svgs/crossCircle.svg": 52302,
	"./Svgs/cursorclick.svg": 48249,
	"./Svgs/custom_positions_tournaments.svg": 49933,
	"./Svgs/download.svg": 50912,
	"./Svgs/endgamewhite.svg": 2791,
	"./Svgs/euros.svg": 20873,
	"./Svgs/expert_cheat_detection.svg": 21728,
	"./Svgs/expired_svg_renewal_icon.svg": 15599,
	"./Svgs/fully_private_games.svg": 32788,
	"./Svgs/gameplay_assistant.svg": 88162,
	"./Svgs/giftIcon.svg": 47563,
	"./Svgs/goldMedal.svg": 88586,
	"./Svgs/green-chessboard.jpg": 52961,
	"./Svgs/green.svg": 60978,
	"./Svgs/greycircle.svg": 42637,
	"./Svgs/hint.svg": 36931,
	"./Svgs/home_page/AI-enabled Caissa.svg": 77519,
	"./Svgs/home_page/Frame.svg": 37668,
	"./Svgs/home_page/Frame1.svg": 4622,
	"./Svgs/home_page/Frame2.svg": 34850,
	"./Svgs/home_page/Frame3.svg": 23963,
	"./Svgs/home_page/PRO.svg": 62535,
	"./Svgs/home_page/Union.svg": 98495,
	"./Svgs/home_page/arrow_down.svg": 2189,
	"./Svgs/home_page/arrow_up.svg": 33381,
	"./Svgs/home_page/assessment.svg": 41061,
	"./Svgs/home_page/badge.svg": 89300,
	"./Svgs/home_page/beginners_curve.svg": 27008,
	"./Svgs/home_page/books_videos.svg": 95245,
	"./Svgs/home_page/bottomLeftSquare.svg": 85625,
	"./Svgs/home_page/bottomRightSquare.svg": 36059,
	"./Svgs/home_page/caissa.svg": 48103,
	"./Svgs/home_page/calculation_trainer.svg": 6944,
	"./Svgs/home_page/chat.svg": 67472,
	"./Svgs/home_page/chess_events.svg": 4475,
	"./Svgs/home_page/chessboard_left_part_large.svg": 47099,
	"./Svgs/home_page/chessboard_part_left.svg": 16073,
	"./Svgs/home_page/chessboard_part_right.svg": 6715,
	"./Svgs/home_page/chessboard_right_part_large.svg": 90246,
	"./Svgs/home_page/cropped_dashboard.svg": 45019,
	"./Svgs/home_page/double_arrow_up.svg": 46399,
	"./Svgs/home_page/four_squares.svg": 86378,
	"./Svgs/home_page/game_analytics.svg": 77296,
	"./Svgs/home_page/game_play.svg": 21114,
	"./Svgs/home_page/intermediate.svg": 11033,
	"./Svgs/home_page/intuition_trainer.svg": 82185,
	"./Svgs/home_page/learning.svg": 39670,
	"./Svgs/home_page/logo.svg": 520,
	"./Svgs/home_page/organisation_trophy.svg": 82484,
	"./Svgs/home_page/parental_control.svg": 80179,
	"./Svgs/home_page/play.svg": 51056,
	"./Svgs/home_page/player.svg": 20112,
	"./Svgs/home_page/positions_trainer.svg": 41391,
	"./Svgs/home_page/review.svg": 59451,
	"./Svgs/home_page/rules.svg": 56636,
	"./Svgs/home_page/signup_assess.svg": 40720,
	"./Svgs/home_page/signup_elevate.svg": 30558,
	"./Svgs/home_page/square.svg": 34467,
	"./Svgs/home_page/square_background.svg": 81998,
	"./Svgs/home_page/sync_obt.svg": 36945,
	"./Svgs/home_page/tournament.svg": 52886,
	"./Svgs/home_page/two_squares.svg": 77323,
	"./Svgs/iosqr.jpg": 3895,
	"./Svgs/knights_elephant.png": 10646,
	"./Svgs/largest_learning_community.svg": 8223,
	"./Svgs/leagueBackground.svg": 95680,
	"./Svgs/learning/arrow.svg": 49274,
	"./Svgs/learning/assessment.svg": 38202,
	"./Svgs/learning/blunder-icon.svg": 31980,
	"./Svgs/learning/gamified-experience.svg": 293,
	"./Svgs/learning/inaccuracy-icon.svg": 73164,
	"./Svgs/learning/master-games.svg": 37118,
	"./Svgs/learning/mistakes-icon.svg": 94955,
	"./Svgs/learning/personalized-content.svg": 56834,
	"./Svgs/learning/slash.svg": 39557,
	"./Svgs/left.svg": 82298,
	"./Svgs/leftbackground.svg": 98031,
	"./Svgs/levelUnitEmpty.svg": 93088,
	"./Svgs/levelUnitEmptyBrown.svg": 99225,
	"./Svgs/levelUnitFilled.svg": 21276,
	"./Svgs/levelUnitFilledBrown.svg": 80083,
	"./Svgs/lichess.png": 4674,
	"./Svgs/lichess.svg": 59498,
	"./Svgs/logo.svg": 18788,
	"./Svgs/logo/logo.svg": 14250,
	"./Svgs/logoicon.svg": 95303,
	"./Svgs/mainappbanner.jpg": 52022,
	"./Svgs/message-chat-circle.svg": 68951,
	"./Svgs/message.svg": 20061,
	"./Svgs/middle.svg": 2768,
	"./Svgs/mobile_bg.svg": 29374,
	"./Svgs/mobile_corner_prize.svg": 90860,
	"./Svgs/new_book_icon.svg": 94265,
	"./Svgs/no_issue_selected.svg": 36515,
	"./Svgs/pattern.svg": 1364,
	"./Svgs/pawnpair.svg": 60161,
	"./Svgs/pawns.svg": 27086,
	"./Svgs/peopleGroup.svg": 87622,
	"./Svgs/person_playing_chess.svg": 48578,
	"./Svgs/phoneCall copy.svg": 69328,
	"./Svgs/phoneCall.svg": 86380,
	"./Svgs/pink.svg": 16854,
	"./Svgs/playerSelected.svg": 63708,
	"./Svgs/playstore.svg": 53596,
	"./Svgs/points.svg": 52957,
	"./Svgs/pointsCoinIcon.svg": 31288,
	"./Svgs/prize.svg": 91395,
	"./Svgs/prizeapp.svg": 24246,
	"./Svgs/prizereminder.svg": 28829,
	"./Svgs/proIg.svg": 983,
	"./Svgs/purple.svg": 8244,
	"./Svgs/puzzle_attempts.svg": 94132,
	"./Svgs/puzzle_timer.svg": 78441,
	"./Svgs/quote.png": 2733,
	"./Svgs/rectangles.svg": 44929,
	"./Svgs/reflects_your_rating.svg": 2447,
	"./Svgs/right.svg": 21615,
	"./Svgs/select_avatar.svg": 50299,
	"./Svgs/silhouette-male-icon.svg": 99438,
	"./Svgs/silverMedal.svg": 38943,
	"./Svgs/singular_ecosystem.svg": 14264,
	"./Svgs/speedometer.svg": 86076,
	"./Svgs/squares.svg": 31671,
	"./Svgs/thumsdown.svg": 42761,
	"./Svgs/thumsdownActive.svg": 98219,
	"./Svgs/thumsup.svg": 1949,
	"./Svgs/thumsupActive.svg": 67133,
	"./Svgs/toprightbg.svg": 58472,
	"./Svgs/tournament_banner/Union.svg": 8507,
	"./Svgs/tournament_banner/background_pattern.svg": 57970,
	"./Svgs/tournament_banner/background_pattern_mobile.svg": 53642,
	"./Svgs/tournament_banner/bannerMain.svg": 48865,
	"./Svgs/tournament_banner/banner_main.svg": 88398,
	"./Svgs/tournament_banner/bg_pattern.svg": 52237,
	"./Svgs/tournament_banner/black_bg_pattern.svg": 3395,
	"./Svgs/tournament_banner/calendar.svg": 70157,
	"./Svgs/tournament_banner/check_icon.svg": 17702,
	"./Svgs/tournament_banner/corner_prize.svg": 97335,
	"./Svgs/tournament_banner/corner_prize_mobile.svg": 38821,
	"./Svgs/tournament_banner/currency-circle.svg": 9015,
	"./Svgs/tournament_banner/detail_pattern.svg": 26620,
	"./Svgs/tournament_banner/gukesh.svg": 71814,
	"./Svgs/tournament_banner/hat.svg": 72130,
	"./Svgs/tournament_banner/image_1.svg": 38425,
	"./Svgs/tournament_banner/image_2.svg": 43194,
	"./Svgs/tournament_banner/image_3.svg": 97462,
	"./Svgs/tournament_banner/onboarding_tournament.svg": 55338,
	"./Svgs/tournament_banner/puzzle.svg": 82456,
	"./Svgs/tournament_banner/yellowBg.svg": 42566,
	"./Svgs/tournament_friends.svg": 19285,
	"./Svgs/trend-up-01.svg": 56929,
	"./Svgs/union.svg": 85176,
	"./Svgs/userIcon.svg": 97748,
	"./Svgs/wrong.svg": 10440,
	"./Svgs/yellow.svg": 79130,
	"./Svgs/yellowleft.svg": 34972,
	"./Svgs/yellowright.svg": 44957,
	"./Svgs/zero_assessments_state.svg": 455,
	"./Tournaments/no_pairing.svg": 4828,
	"./Tournaments/no_standing.svg": 54478,
	"./Tournaments/no_tournament_found.svg": 28114,
	"./Workbook/WorkbookEmptyPage.svg": 71044,
	"./bishop.png": 37303,
	"./cursor-click.svg": 79484,
	"./glyphs/thumbsdown.svg": 52906,
	"./glyphs/thumbsup.svg": 37716,
	"./glyphs/tick.svg": 95525,
	"./hide.svg": 20743,
	"./icons/Rematch.png": 21437,
	"./icons/Rematch@2x.png": 4414,
	"./icons/Rematch@3x.png": 63174,
	"./icons/close.png": 70496,
	"./icons/tick.png": 24892,
	"./icons/tick@2x.png": 15999,
	"./icons/tick@3x.png": 62242,
	"./lock.png": 21925,
	"./pawn.png": 50873,
	"./png/PRO.png": 83081,
	"./png/abort.png": 48122,
	"./png/back_arrow.png": 65840,
	"./png/badge.png": 57854,
	"./png/beginners_curve.png": 54474,
	"./png/black_box.png": 20447,
	"./png/black_color.png": 71001,
	"./png/black_rook.png": 73468,
	"./png/book-closed.png": 837,
	"./png/book.png": 30780,
	"./png/book_dummy.png": 50684,
	"./png/bottom_left_square.png": 81923,
	"./png/bottom_right_square.png": 13117,
	"./png/casual_player.png": 22554,
	"./png/challenge.png": 27861,
	"./png/challenge@2x.png": 24853,
	"./png/challenge@3x.png": 46968,
	"./png/chapter.png": 48548,
	"./png/chart.png": 48113,
	"./png/chat.png": 410,
	"./png/checkmark.png": 5198,
	"./png/chess_events.png": 27906,
	"./png/chess_footer_background.png": 68888,
	"./png/chessboard_left_part_large.png": 69042,
	"./png/chessboard_part_left.png": 20695,
	"./png/chessboard_part_placeholder.png": 57953,
	"./png/chessboard_part_right.png": 47097,
	"./png/chessboard_right_part_large.png": 14334,
	"./png/circle_chess_logo.png": 98073,
	"./png/circle_chess_logo_black.png": 87975,
	"./png/circlechess_screenshot.png": 59135,
	"./png/custom_rules_icon.png": 53786,
	"./png/custom_rules_modal.png": 61817,
	"./png/defeat_result.png": 307,
	"./png/delete.png": 24290,
	"./png/diagonal_chess_part.png": 66013,
	"./png/double_arrow_up.png": 3742,
	"./png/draw.png": 25068,
	"./png/draw_result.png": 19066,
	"./png/dropdown.png": 75604,
	"./png/elevate.png": 98267,
	"./png/empty_book.png": 82470,
	"./png/empty_result.png": 17454,
	"./png/endgame.png": 86420,
	"./png/engine.png": 12545,
	"./png/eye.png": 3396,
	"./png/file.png": 21644,
	"./png/gamesummary.png": 73771,
	"./png/go_back.png": 65451,
	"./png/home.png": 57193,
	"./png/intermediate.png": 91229,
	"./png/late_guess.png": 3654,
	"./png/learning.png": 98259,
	"./png/level_unit_empty.png": 44989,
	"./png/level_unit_filled.png": 608,
	"./png/master.png": 33733,
	"./png/middlegame.png": 68504,
	"./png/mobileOne.png": 47912,
	"./png/newGame.png": 8635,
	"./png/opening.png": 30490,
	"./png/opening2.png": 11723,
	"./png/organisation_trophy.png": 68476,
	"./png/player.png": 46734,
	"./png/random_color.png": 23987,
	"./png/record_button.png": 75375,
	"./png/refresh.png": 95019,
	"./png/resign.png": 56040,
	"./png/review_game.png": 98135,
	"./png/search.png": 86570,
	"./png/settings.png": 16390,
	"./png/settings_close.png": 58946,
	"./png/shopping-bag.png": 43808,
	"./png/signup_assess.png": 46976,
	"./png/signup_elevate.png": 15751,
	"./png/signup_play.png": 9234,
	"./png/square_background.png": 63104,
	"./png/stockfish_settings.png": 61567,
	"./png/stop_record.png": 25490,
	"./png/trash.png": 39241,
	"./png/upload.png": 93296,
	"./png/voice_process.png": 44296,
	"./png/whatsapp_say_hi.png": 91132,
	"./png/whatsapp_share.png": 10738,
	"./png/white_box.png": 60391,
	"./png/white_color.png": 84524,
	"./png/white_rook.png": 33045,
	"./png/win_result.png": 52842
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29536;